import { useQuery } from '@tanstack/react-query'

import requests from 'service/api'

import SearchSelect from '../search-select'
import { useEffect, useState, useMemo } from 'react'
import { useFormikContext } from 'formik'

export function SelectFabricListPrice12({ name, idx, idx2 ,brrand,index }) {
  const { values } = useFormikContext()
  const [selected, setSelected] = useState(null)

  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'fabric'],
    queryFn: async () => {
      if (brrand === "ZaraHome") {
        const { data } = await requests.fabric.listHome()
        return data
      } else {
        const { data } = await requests.fabric.list()
        return data
      }
    },
    placeholderData: []
  })

  const options = useMemo(() => data?.map(({ name }) => ({
    label: name,
    value: name
  })) || [], [data])

  useEffect(() => {
    if (
      values.zaraHomeLabel12?.[idx]?.fabric?.[idx2]?.name && 
      isFetched &&
      options.length > 0
    ) {
      const select = options.find(
        ({ value }) => value === values.zaraHomeLabel12[idx].fabric[idx2].name
      )
      setSelected(select)
    } else {
      // Reset selection if no valid data
      setSelected(null)
    }
    // eslint-disable-next-line
  }, [values.zaraHomeLabel12?.[idx]?.fabric?.[idx2]?.name, isFetched, idx2, options])

  return (
    <SearchSelect
      className="grid-cols-1 items-start"
      name={name}
      options={options}
      value={selected}
      onChange={(e) => setSelected(e)}
    />
  )
}
